import { ReactElement } from 'react';
import { NavLink } from '@localstack/ui';
import { buildRoute } from '@localstack/services';

import { EC2Routes } from '../../types';

interface Props {
  routes: EC2Routes;
}

export const NavTabs = ({ routes }: Props): ReactElement => (
  <>
    <NavLink to={buildRoute(routes.RESOURCES_EC2)} end>
      Instances
    </NavLink>
    <NavLink to={buildRoute(routes.RESOURCES_EC2_VPCS)}>VPCs</NavLink>
    <NavLink to={buildRoute(routes.RESOURCES_EC2_SECURITY_GROUPS)}>Security Groups</NavLink>
    <NavLink to={buildRoute(routes.RESOURCES_EC2_LBV2)} pro>
      Load Balancers
    </NavLink>
  </>
);
